module.exports = __webpack_public_path__ + "static/media/painel_financ.eccc674f.png";